<div *ngIf="bannerMessages.length > 0" [routerLink]="['admin/feature-mgmt']"
  class="flex flex-row flex-auto w-full h-full bg-warn max-h-8 min-h-8 text-center text-on-warn items-center justify-center cursor-pointer max-w-full">
    <div class="flex flex-row w-full line-clamp-1 text-sm sm:text-lg items-center justify-center gap-2"  [class.fade-out]="!bannerVisible"  [class.fade-in]="bannerVisible">
          {{ bannerContent }}
      </div>
    <mat-icon [svgIcon]="'heroicons_outline:exclamation-circle'" class="text-white icon-size-6 mx-2"> </mat-icon>

</div>
